import { map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { StableGroup } from '../_models/stableGroup';
import { Stable } from '../_models/stable';

@Injectable()
export class StableGroupService {
  // Services
  private http = inject(HttpClient);

  private apiBaseUrl = environment.apiBaseUrl;
  groupStableList: StableGroup[];
  groupStableList$: BehaviorSubject<Array<StableGroup>> = new BehaviorSubject<Array<StableGroup>>(
    []
  );
  constructor() {}

  getStableGroups(): Observable<StableGroup[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/stablegroups').pipe(
      map((response) => {
        this.groupStableList = response;
        this.groupStableList$.next(response);
        return response;
      })
    );
  }
  getStableGroup(id: number): Observable<StableGroup> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/stablegroups/' + id)
      .pipe(map((response) => response));
  }
  saveStableGroup(stableGroupItem: StableGroup): Observable<StableGroup> {
    const stableGroup = { ...stableGroupItem };
    delete stableGroup.lastUpdated;
    delete stableGroup.dateCreated;

    if (stableGroup.stables) {
      const arr: Array<any> = [];
      stableGroup.stables.forEach((element) => {
        const idfield: any = {
          id: element.id,
        };
        arr.push(idfield);
      });
      stableGroup.stables = arr;
    }
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    stableGroup.companyId = companySelected ? companySelected.id : null;

    if (stableGroup.id) {
      return this.http
        .put<StableGroup>(
          this.apiBaseUrl + 'api/private/v1/stablegroups/' + stableGroup.id,
          stableGroup
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<StableGroup>(this.apiBaseUrl + 'api/private/v1/stablegroups/', stableGroup)
        .pipe(map((response) => response));
    }
  }
  deleteStableGroup(stableGroup: StableGroup): Observable<StableGroup> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/stablegroups/' + stableGroup.id).pipe(
      map(() => {
        return { id: stableGroup.id } as StableGroup;
      })
    );
  }

  getStableGroupAreaFromStables(stableGroup: StableGroup, stables: Stable[]) {
    let Area = 0;

    _.forEach(stables, (stable) => {
      if ((stable.group ? stable.group.id : null) === (stableGroup ? stableGroup.id : null)) {
        Area += +stable.size;
      }
    });
    return Area;
  }

  getStableGroupById(id: number): StableGroup {
    return this.groupStableList.find((s) => s.id === id);
  }
}
